import React from 'react'
import { styled } from '@mui/material/styles'

import { palette } from '../../muiTheme'

const StyledBar = styled('div')`
  background: ${({ theme }) => theme.colors.grayGray3};
  border-radius: 8px;
  width: 100%;
  position: relative;
  height: 8px;
`

const StyledProgress = styled('div', {
  shouldForwardProp: prop => prop !== 'fractionalWidth',
})<{ fractionalWidth: number }>`
  position: 'absolute';
  background: ${({ color }) => color};
  width: ${({ fractionalWidth }) => `${100 * Math.min(fractionalWidth, 1)}%`};
  border-radius: 8px;
  height: 8px;
`

export interface ProgressBarProps {
  readonly color?: string
  readonly currentStep: number
  readonly totalSteps: number
}

export function ProgressBar({
  color = palette.chewyPrimary,
  currentStep,
  totalSteps,
}: ProgressBarProps) {
  return (
    <StyledBar>
      <StyledProgress
        color={color}
        fractionalWidth={currentStep / totalSteps}
      />
    </StyledBar>
  )
}
